import $ from 'jquery';
import '../vendor/gwrf.js';
import 'select2';

class Forms {

	constructor(element) {
		$(document).ready(() => this.load());
		this.shownPages = [1];
	}

	load() {
		if($('.qaform').length) {
			new gwrf({"el":$('.qaform'),"formId":7, "spinnerUrl": "{spinner_url}", "refreshTime": 0})
		}

		if($('.gform_wrapper select').length) {
			$('.gform_wrapper select').select2({
				minimumResultsForSearch: -1
			})
		}
		$(document).on("gform_page_loaded", (event, form_id, current_page) => this.loadChatPage(event, form_id, current_page) );
		$(document).on("change","div.twz-element-chat .gfield_radio input", this.submitChatPage);
		$(document).on("change","div.twz-element-chat .ginput_container_consent input", this.submitChatPage);
		$(document).on('submit','#gform_2',this.submitChatForm);
		$(document).on('gform_post_render', this.scrolltoBottom);
	}

	submitChatForm(e) {
		e.preventDefault();
		let chat_choice = $(e.currentTarget).find('.gfield_radio input:checked').val();

		$.get(TWZ.ajaxurl +'?action=twz_get_form&form_id='+chat_choice,function(response){
			$('.twz-element-chat__form--next').html(response).addClass('twz-element-chat__form--active');

			setTimeout(function() {
				if($('.twz-element-chat__form--next .gform_page').length) {
					$('.twz-element-chat__form--next .gform_page').addClass('pageinprogress')
						.find('input,textarea').focus();
				} else {
					$('.twz-element-chat__form--next .gform_wrapper').addClass('forminprogress')
				}

			},100)
		});
	}

	submitChatPage() {
		var field = $(this).parents('li.gfield');
		field.addClass('answered');
		setTimeout(function() {
			field.hide(0)
		},500)
		setTimeout(function() {
			field.parents('form:first').trigger('submit');
		},200)
	}

	loadChatPage(event, form_id, current_page) {

		if(form_id != 3 && form_id != 4 && form_id != 5 && form_id != 6) return;

		this.shownPages.push(parseInt(current_page));
		$.each(this.shownPages,(index,el) =>  {
			if(el == current_page) return;
			jQuery("div.twz-element-popup.active #gform_page_" + form_id + "_" + el).addClass("pagecomplete");
		})

		if($('.gform_page .gfield_error').length) {
			$('.gform_page .gfield_error').parents('.gform_page').addClass('pagenotvalidating');
		}

		setTimeout(function() {
			jQuery("div.twz-element-popup.active #gform_page_" + form_id + "_" + current_page)
				.addClass("pageinprogress")
				.find('input,textarea').focus();
		},10)

		$.each(this.shownPages,(index,el) => {
			if ($('#gform_page_' + form_id + '_' + el + ' .you').length) {
				let youclasses = $('#gform_page_' + form_id + '_' + el + ' .you').attr('class');
				let kek = youclasses.split('inputvalue_');
				if(kek.length > 1) {
					let inputvalue = kek[1].split(" ");
					inputvalue = inputvalue[0];
					let previnput = $('#gform_' + form_id + ' [name="input_' + inputvalue + '"]');
					$('#field_' + form_id + '_' + inputvalue).hide();
					if (previnput.attr('type') == 'radio') {
						var previnputvalue = $('#gform_' + form_id + ' [name="input_' + inputvalue + '"]:checked').val();
					} else {
						var previnputvalue = previnput.val();
					}
					$('#gform_page_' + form_id + '_' + el + ' .you').html(previnputvalue)
				}
			}
		});
	}
	scrolltoBottom() {
		if($('.twz-element-popup.active').length) {
			$('.twz-element-popup.active').animate({
				scrollTop: parseInt($('.twz-element-popup.active')[0].scrollHeight)
			}, 1000);
		}
	}
}

new Forms